/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validators_Image_UrlInputs */

const en_validators_image_url = /** @type {(inputs: Validators_Image_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid image URL. (Valid image URLs usually end with .jpg, .jpeg, .png, .svg or .webp)`)
};

const de_validators_image_url = /** @type {(inputs: Validators_Image_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige Bild-URL ein. (Gültige Bild-URLs enden in der Regel auf .jpg, .jpeg, .png, .svg oder .webp)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid image URL. (Valid image URLs usually end with .jpg, .jpeg, .png, .svg or .webp)" |
*
* @param {Validators_Image_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validators_image_url = /** @type {((inputs?: Validators_Image_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validators_Image_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validators_image_url(inputs)
	return de_validators_image_url(inputs)
});